import { useTranslation } from 'react-i18next';

function OrganisationSupportCreditsPage() {
  const { t } = useTranslation();
  return <h1>{t('pages.organisation_support_credits.title')}</h1>;
}

export default OrganisationSupportCreditsPage;
